import React, { useCallback, useEffect } from 'react';
import {
  ReferenceInput,
  AutocompleteInput,
  TextInput,
  required,
  useTranslate,
  useDataProvider,
} from 'react-admin';
import { useFormContext, useWatch } from 'react-hook-form';

/**
 * Venue Selector Component
 * Handles venue selection with city auto-population (create + edit)
 */
export const VenueSelector = ({ disabled = false }) => {
  const translate = useTranslate();
  const { setValue } = useFormContext();
  const dataProvider = useDataProvider();
  const venueId = useWatch({ name: 'venue' });

  const syncCityFromVenue = useCallback(
    async (id) => {
      if (!id) {
        setValue('city', '', { shouldDirty: false });
        return;
      }
      try {
        const res = await dataProvider.getOne('venues', { id });
        if (res?.data?.city != null && res.data.city !== '') {
          setValue('city', res.data.city, { shouldDirty: false });
        }
      } catch (error) {
        console.error('Error fetching venue city:', error);
      }
    },
    [dataProvider, setValue],
  );

  useEffect(() => {
    if (venueId) {
      syncCityFromVenue(venueId);
    }
  }, [venueId, syncCityFromVenue]);

  const handleVenueChange = async (value) => {
    const id = value?.target?.value ?? value;
    await syncCityFromVenue(id);
    setValue('layoutID', null);
  };

  return (
    <React.Fragment>
      <ReferenceInput
        source="venue"
        reference="venues"
        label={translate('form.venue', 'Venue')}
        sort={{ field: 'name', order: 'ASC' }}
        perPage={200}
        enableGetChoices={() => true}
      >
        <AutocompleteInput
          optionText="name"
          label={translate('form.venue', 'Venue')}
          placeholder={translate('form.select_venue', 'Mekan seçin…')}
          fullWidth
          matchSuggestion={() => true}
          filterToQuery={(searchText) => ({ name: searchText })}
          validate={required()}
          disabled={disabled}
          onChange={handleVenueChange}
        />
      </ReferenceInput>

      {venueId ? <TextInput source="city" label={translate('form.city', 'City')} fullWidth disabled /> : null}
    </React.Fragment>
  );
};
